import signImg from '../../assets/images/Login.jpg'
import logo from '../../assets/images/h_logo.png'
import { Formik, Field } from 'formik'
import * as Yup from 'yup'
import React, { useState, useEffect } from "react";
import { API_STATUS } from '../../constants';
import { loginApi } from '../../apis/login/user_login';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { remove_user_login, set_user_login } from '../../redux/VerifyLogin';
import SetLoginToken from '../../utils/setlogintoken';
import { reloadState } from '../../redux/GlobalSlice';
import { GetActiveUser } from '../../apis/user/get_active_user';

export default function LoginModel() {

    const dispatch = useDispatch();
    const authState = useSelector(state => state.checkuserlogin);
    const navigate = useNavigate();

    const [login, setLogin] = useState(API_STATUS);
    const [errMsg, setErrMsg] = useState('');
    const [userApi, setUserApi] = useState(API_STATUS);

    useEffect(() => {
        if (authState.isLogin) {
            GetActiveUser(setUserApi);
        }
    }, [authState]);

    useEffect(() => {
        if (!userApi.isLoader && !userApi.isError) {
            if (userApi.data == null) {

            } else {
                let res = userApi.data;
                if (res['status'] === 409) {
                    //ulogout();
                } else {
                    if (res.data['status'] === 2) {
                        navigate('/account_status');
                    }
                    sessionStorage.setItem('LOGIN_DATA', JSON.stringify(res.data));
                    localStorage.setItem('LOGIN_DATA', JSON.stringify(res.data));

                    sessionStorage.setItem('KYC', res.data['kyc']);
                    sessionStorage.setItem('DECLARATION', res.data['declaration']);
                    sessionStorage.setItem('LIVENESS', res.data['liveness']);
                    sessionStorage.setItem('USER_TYPE', res.data['userType']);

                    localStorage.setItem('KYC', res.data['kyc']);
                    localStorage.setItem('DECLARATION', res.data['declaration']);
                    localStorage.setItem('LIVENESS', res.data['liveness']);
                    localStorage.setItem('USER_TYPE', res.data['userType']);

                    dispatch(reloadState({ 'refresh_login': true }));

                    window.location.reload();
                }
            }
        }
    }, [userApi]);

    useEffect(() => {
        if (!login.isError && !login.isLoader) {
            if (login.data != null) {
                const res = login.data;

                if (res['status'] === 1) {
                    let authBody = { "token": res.data['token'], "code": res.data['code'], "type": res.data['type'].toString() };
                    SetLoginToken(authBody);
                    dispatch(set_user_login(authBody));
                } else {
                    setErrMsg("Wrong username / password");
                }
            }
        } else if (login.isError) {
            setErrMsg("Network error");
        }
    }, [login]);


    const SignupSchema = Yup.object().shape({
        username: Yup.string()
            .min(4, 'Too Short!')
            .max(50, 'Too Long!')
            .required('Enter username'),
        password: Yup.string()
            .min(6, 'Too Short!')
            .required('Enter password')
    });

    return <div>
        <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css" />

        <div className="container px-4 text-center">
            <div className="row justify-content-center pb-100 pt-100">

                <div className="col-md-4">
                    <Formik
                        initialValues={{
                            username: "",
                            password: "",
                        }}
                        validationSchema={SignupSchema}
                        onSubmit={values => {
                            let body = values;
                            setErrMsg('');
                            loginApi(body, setLogin);
                        }}
                    >
                        {({ values, errors, touched, isValid, handleChange, setFieldTouched, setFieldValue, handleSubmit }) => (
                            <div className="card bg-white shadow py-3">
                                <div className="card-body">
                                    <div className="row justify-content-center" style={{ paddingBottom: 20 }}>
                                        <img src={logo} alt='' style={{ width: 275 }} />
                                    </div>
                                    {
                                        errMsg !== "" &&
                                        <div className='alert text-danger' style={{ textAlign: 'left' }}>
                                            <strong>Failed !!</strong><br />
                                            {errMsg}
                                        </div>
                                    }
                                    <div className="row">
                                        <div className="col-lg-12 col-md-12 col-sm-12 col-12 mb-3">

                                            <div className="contact-field">
                                                <Field className="form-control" type="email" name="username" placeholder="Username*" />
                                            </div>
                                            {
                                                errors.username && touched.username &&
                                                <div className='text-danger'>{errors.username}</div>
                                            }
                                        </div>
                                        <div className="col-lg-12 col-md-12 col-sm-12 col-12 mb-3">
                                            <div className="contact-field">
                                                <Field className="form-control" type="password" name="password" placeholder="Password*" />
                                            </div>
                                            {
                                                errors.password && touched.password &&
                                                <div className='text-danger'>{errors.password}</div>
                                            }
                                        </div>
                                    </div>
                                    <div className="row mt-3">
                                        <div className="col-md-12">
                                            {
                                                login.isLoader &&
                                                <div className="spinner-border text-primary" role="status">
                                                </div>
                                            }
                                            {
                                                !login.isLoader &&

                                                <button
                                                    onClick={() => {
                                                        if (!isValid) {
                                                            setFieldTouched('username');
                                                            setFieldTouched('password');
                                                        } else {
                                                            handleSubmit();
                                                        }
                                                    }}
                                                    type="button" className="button_slide slide_right orange" style={{ width: '100%' }}>Login</button>
                                            }
                                        </div>
                                    </div>
                                    <div className="row mt-3">
                                        <div className="col-md-12 flex" style={{ justifyContent: 'space-between' }}>
                                            <a href="/ret_username" style={{ textDecoration: 'none', color: '#000' }}> Forgot username? </a>
                                            <a href="/ret_password" style={{ textDecoration: 'none', color: '#000' }}> Forgot password? </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </Formik>
                    <br />

                    <div className="card bg-white shadow py-3">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-lg-12 col-md-12 col-sm-12 col-12">

                                    <p style={{ color: '#969696' }}>Don't have an account <a style={{ color: '#0d6efd' }} href="/select_cat">Sign up</a> </p>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
}